import React from "react";
import { escapeInvisibles, splitByMatches } from "./escape";

export function RawTextViewer({ text, matches = [] }) {
  const marked = escapeInvisibles(text || "");
  const spans = splitByMatches(marked, matches);
  return (
    <pre data-testid="raw-text-viewer"
         style={{ whiteSpace: "pre-wrap", wordBreak: "break-word",
                  background: "var(--hs-surface)", color: "var(--hs-text)", padding: "0.75rem",
                  borderRadius: 4, fontFamily: "var(--hs-font-mono)", fontSize: 13,
                  margin: 0, overflowX: "auto" }}>
      {spans.map((s, i) => {
        if (s.match) {
          return (
            <span key={i}
                  data-testid="match-span"
                  title={`${s.match.rule_id} · ${s.match.technique} · w=${s.match.weight}`}
                  style={{ textDecoration: "underline wavy var(--hs-warning)",
                           background: "var(--hs-warning-subtle)" }}>
              {s.text}
            </span>
          );
        }
        return <span key={i}>{s.text}</span>;
      })}
    </pre>
  );
}

export function DiffViewer({ diff }) {
  if (!diff) return <div style={{ color: "var(--hs-text-muted)" }}>No previous snapshot.</div>;
  const lines = diff.split("\n");
  return (
    <pre data-testid="diff-viewer"
         style={{ whiteSpace: "pre-wrap", background: "var(--hs-surface)", padding: "0.75rem",
                  borderRadius: 4, fontFamily: "var(--hs-font-mono)", fontSize: 12, margin: 0 }}>
      {lines.map((ln, i) => {
        let color = "var(--hs-text-muted)";
        if (ln.startsWith("+") && !ln.startsWith("+++")) color = "var(--hs-safe)";
        else if (ln.startsWith("-") && !ln.startsWith("---")) color = "var(--hs-danger)";
        return <div key={i} style={{ color }}>{ln}</div>;
      })}
    </pre>
  );
}
